var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 40,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 30.5C28.6789 30.5 27 32.1789 27 34.25V36.75C27 37.4404 27.5596 38 28.25 38C28.9404 38 29.5 37.4404 29.5 36.75V34.25C29.5 33.5596 30.0596 33 30.75 33H48.25C48.9404 33 49.5 33.5596 49.5 34.25V46.75C49.5 47.4404 48.9404 48 48.25 48H40.75C40.0596 48 39.5 48.5596 39.5 49.25C39.5 49.9404 40.0596 50.5 40.75 50.5H48.25C50.3211 50.5 52 48.8211 52 46.75V34.25C52 32.1789 50.3211 30.5 48.25 30.5H30.75Z",
    fill: "currentFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 43C27.5596 43 27 43.5596 27 44.25C27 44.9404 27.5596 45.5 28.25 45.5C30.3211 45.5 32 47.1789 32 49.25C32 49.9404 32.5596 50.5 33.25 50.5C33.9404 50.5 34.5 49.9404 34.5 49.25C34.5 45.7983 31.7018 43 28.25 43Z",
    fill: "currentFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40.5C27 39.8096 27.5596 39.25 28.25 39.25C33.7729 39.25 38.25 43.7271 38.25 49.25C38.25 49.9404 37.6904 50.5 37 50.5C36.3096 50.5 35.75 49.9404 35.75 49.25C35.75 45.1079 32.3921 41.75 28.25 41.75C27.5596 41.75 27 41.1904 27 40.5Z",
    fill: "currentFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 50.5C28.9404 50.5 29.5 49.9404 29.5 49.25C29.5 48.5596 28.9404 48 28.25 48C27.5596 48 27 48.5596 27 49.25C27 49.9404 27.5596 50.5 28.25 50.5Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenActive);
export default __webpack_public_path__ + "static/media/ShareScreenActive.fbca4555328c79efd9c3b74cecd412b6.svg";
export { ForwardRef as ReactComponent };